import { useElementSize } from "@vueuse/core"
import { computed, onMounted, watch } from "vue"

// 订阅兑换等模块右侧图片当父元素宽度小于680时隐藏
const useFormImgVisible = (refFormSection, refFormImg) => {
  onMounted(() => {
    const { width: formSectionWidth } = useElementSize(refFormSection)
    const formImgVisible = computed(() => {
      return formSectionWidth.value > 680
    })
    watch(() => formImgVisible.value, (val) => {
      console.log(formSectionWidth.value, val, refFormSection.value)
      if (refFormImg.value) {
        if (val) {
          refFormImg.value.style.display = 'block'
        } else {
          refFormImg.value.style.display = 'none'
        }
      }
    }, { immediate: true })
  })
}

export default useFormImgVisible